/* eslint-disable no-empty-pattern */
import React, { useEffect, useState } from "react"
import KudaAppBadge from "../../assets/img/kuda-app-badge.inline.svg"
import KudaAppStars from "../../assets/img/kuda-app-stars.inline.svg"
import { useLocation } from "@reach/router"

const GetMobile = () => {
  const location = useLocation()
  const [url, setUrl] = useState("")

  useEffect(() => {
    if (
      location.pathname.includes("fireboy") ||
      location.pathname.includes("erica")
    ) {
      setUrl("https://kuda.onelink.me/abUI/fireboy/")
    } else {
      setUrl("https://kuda.onelink.me/abUI/344e3dde/")
    }
  }, [])
  return (
    <div className="kuda-mobile--get">
      <div className="Kuda-ratings flex align-center justify-between column--100">
        <div className="flex align-center">
          <div className="kuda-app--badge">
            <KudaAppBadge />
          </div>
          <div className="kuda-app--stars">
            <p className="kuda-app--name card-main--heading no-margin--bottom text-xbold color-primary">
              Kuda.
            </p>
            <div className="kuda-star--wrap">
              <KudaAppStars />
            </div>
          </div>
        </div>
        <a
          href={url}
          className="kuda-cta kuda_web"
          rel="noopener noreferrer"
          target="_blank"
        >
          Get the App
        </a>
      </div>
    </div>
  )
}
export default GetMobile
